module.exports = __webpack_public_path__ + "static/img/地图.90ea94dc.png";